import { render, staticRenderFns } from "./GroupGrid.vue?vue&type=template&id=2c36b8ba"
import script from "./GroupGrid.vue?vue&type=script&lang=js"
export * from "./GroupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports